import { useEffect } from "react";
import { useLocation, Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";

export default function Layout() {
    const { pathname, hash } = useLocation();
    useEffect(() => {
        if (hash) {
            const el = document.getElementById(hash.replace("#", ""));
            if (el) { setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 80); return; }
        }
        window.scrollTo({ top: 0, behavior: "instant" });
    }, [pathname, hash]);

    return (
        <div className="min-h-screen flex flex-col bg-white">
            <Navbar />
            <main className="flex-1 pt-16 lg:pt-20"><Outlet /></main>
            <Footer />
        </div>
    );
}
